export default __webpack_public_path__ + "static/media/how-it-work1-blue.95834e29.svg";